var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 21.016,
  height: 12.509,
  x: 1.492,
  y: 5.745,
  fill: "#fff",
  stroke: "#000",
  rx: 6.255
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5F6368",
  d: "M11.44 12.245v1.933h-.618V9.403h1.638q.624 0 1.059.413.444.412.444 1.006 0 .607-.444 1.014a1.48 1.48 0 0 1-1.059.406h-1.02zm0-2.254v1.666h1.033q.368-.001.611-.246a.8.8 0 0 0 .248-.585.8.8 0 0 0-.248-.579.8.8 0 0 0-.611-.252H11.44zm4.138.813q.685 0 1.081.364t.396.997v2.014h-.589v-.454h-.026q-.382.56-1.02.56-.544 0-.91-.32a1.02 1.02 0 0 1-.367-.8q0-.508.386-.805.387-.3 1.03-.3.552 0 .904.201v-.14a.7.7 0 0 0-.254-.544.88.88 0 0 0-.599-.223.94.94 0 0 0-.817.434l-.544-.339q.45-.646 1.33-.645m-.798 2.371q0 .24.206.4a.76.76 0 0 0 .48.16q.39 0 .695-.288a.9.9 0 0 0 .305-.674q-.289-.226-.804-.227-.376 0-.628.179-.254.186-.254.45m5.634-2.265-2.06 4.704h-.637l.766-1.646-1.358-3.059h.672l.979 2.346h.012l.953-2.346z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M8.983 11.855q0-.3-.052-.576h-2.59v1.055h1.492c-.06.351-.255.65-.554.85v.684h.888c.519-.476.816-1.18.816-2.013"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M7.28 13.183a1.67 1.67 0 0 1-.938.263c-.72 0-1.33-.482-1.548-1.13H3.88v.705a2.76 2.76 0 0 0 2.463 1.508c.745 0 1.37-.243 1.826-.662z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FABB05",
  d: "M4.708 11.792q.001-.274.086-.524v-.706h-.916a2.72 2.72 0 0 0 0 2.46l.916-.706a1.6 1.6 0 0 1-.086-.524"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#E94235",
  d: "M6.342 10.138c.407 0 .77.14 1.058.41l.787-.78a2.66 2.66 0 0 0-1.845-.713 2.76 2.76 0 0 0-2.463 1.508l.915.705a1.65 1.65 0 0 1 1.548-1.13"
})));
export default SvgGooglePay;